import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { formatStartTime } from 'lib/util/formatStartTime';
import { ProductShape } from 'lib/util/productShape';

import { LocationList } from '../LocationList/LocationList';
import styles from '../ProductDetailsView.module.css';

interface Props {
  product: ProductShape;
}

export const DropoffCheckoutTab = ({ product }: Props) => {
  const { t } = useTranslation();

  const [selectedTimeSlotKey, setSelectedTimeSlotKey] = React.useState<string>(
    product.startTimes.length > 0 ? product.startTimes[0].timeSlotKey : ''
  );
  const handleStartTimeChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedTimeSlotKey(event.target.value);

  const showDropoffSection = product.dropoffLocations.length > 0;
  const showCheckoutSection = product.checkoutLocations.length > 0;

  const selectedStartTime = product.startTimes.find(
    (startTime) => startTime.timeSlotKey === selectedTimeSlotKey
  );

  return (
    <>
      <label className={styles['overview__content__item__select']}>
        <select name="startTime" value={selectedTimeSlotKey} onChange={handleStartTimeChange}>
          {product.startTimes.map((startTime) => (
            <option key={startTime.timeSlotKey} value={startTime.timeSlotKey}>
              {formatStartTime(startTime)}
            </option>
          ))}
        </select>
      </label>
      {showDropoffSection && (
        <div className={styles['overview__content__item__scheds']}>
          <p className={styles['overview__content__item__ttl']}>{t('Dropoff Locations / Times')}</p>
          <LocationList startTime={selectedStartTime} locations={product.dropoffLocations} />
        </div>
      )}
      {showCheckoutSection && (
        <div className={styles['overview__content__item__scheds']}>
          <p className={styles['overview__content__item__ttl']}>
            {t('Checkout Times / Locations')}
          </p>
          <LocationList startTime={selectedStartTime} locations={product.checkoutLocations} />
        </div>
      )}
    </>
  );
};
